function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M134.29 53.72L42.03 146.5l-38 9.46 9.51-38 92.68-92.68 28.11 28.42 15.45-15.45c7.81-7.8 8.22-20.63.41-28.42a20.3 20.3 0 00-28.52 0L106.18 25.3"
});

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 159.81 160",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgEdit;